import React from "react"
import { WhiteDiv } from "../components/whitediv"
import { Layout } from "../components/baselayout"
import { NewsItem } from "../components/newsitem"
import { Link } from "gatsby"
const six16 = require("../images/news/6Bell16.jpg")
const alt17 = require("../images/news/AltDinner17.jpg")
const alt18 = require("../images/news/AltDinner18.jpg")
const art = require("../images/news/ART-1.jpg")
const boat17 = require("../images/news/BoatRace17.jpg")
const dinner17 = require("../images/news/Dinner 2017.jpg")
const dinner18 = require("../images/news/Dinner 2018.jpg")
const hols17 = require("../images/news/GH17.jpg")
const ny17 = require("../images/news/GNY17.jpg")
const ny18 = require("../images/news/GNY18.jpg")
const week16 = require("../images/news/GW16.jpg")
const joint18 = require("../images/news/JointOuting18.jpg")
const sua16 = require("../images/news/SUA16.jpg")
const xmas16 = require("../images/news/XD16.jpg")
const freshers16 = require("../images/news/Freshers16.jpg")
const letter16 = require("../docs/news/Newsletter16.pdf")
const letter17 = require("../docs/news/Newsletter17.pdf")

const OldNews: React.FC = () => (
  <Layout title="Old News">
    <WhiteDiv>
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        <div style={{ flexBasis: "50%", flexGrow: 1 }}>
          <h1>News and Events</h1>
          <hr />
          <NewsItem title="Guild Holiday - 24th-31st August 2018">
            <p>
              Beach, walks, board games, park run, escape room, and, oh yeah,
              ringing. What have all these things got in common? They’re just a
              few of the things that we got up to on our holiday. County Durham
              was the destination with a large farmhouse providing the
              accommodation.
            </p>
            <p>
              In case you were wondering, yes, the beach trip did see some of us
              foolish enough to actually go into the sea, and yes, it was cold.
              Make that freezing. As for the escape room, well, luckily everyone
              escaped so we didn’t have to leave anyone behind in Durham.
              Ringing wise, there was some more ‘traditional’ ringing with some
              of us ringing in Durham on Sunday, including at the Cathedral, and
              a quarter peal of Yorkshire surprise major at Lanchester. There
              was also some less ‘typical’ ringing in the form of the bells at
              Frosterley, a 12 bell mini-ring owned by the Black Bull pub (and
              hence very conveniently situated for any refreshments). We also
              found ourselves ringing in an art gallery while on our Hartlepool
              outing. It would be an understatement to say that those bells were
              very loud.
            </p>
            <p>
              Thank you to all the local ringers who let us ring while we were
              there and to everyone who helped with organising the holiday, from
              accommodation and travel, to food and various activities. A big
              thank you to all the drivers and to everyone for coming and making
              it such an enjoyable holiday!
            </p>
            Melissa Nash - Master, CUGCR
          </NewsItem>
          <NewsItem title="Alternative Dinner - 14th June 2018" image={alt18}>
            A break from tradition took us to Brown's restaurant, rather than a
            college, for this year's Alternative Dinner. Bubbly pre-drinks in
            the Deer Park, tasty food, a cocktail or two, followed by port and
            cheese back at Peterhouse. Quite the birthday party for Secretary
            Imogen! Thank you very much to James E for sacrificing his room for
            post-dinner drinks.
          </NewsItem>
          <NewsItem title="Guild Dinner - 17th March 2018" image={dinner18}>
            Downing College provided the setting for this year's annual dinner.
            It was preceded by four successful quarter peals and one peal rung
            by Guild members during the day, which can be seen on Bellboard. The
            speeches this year came from Phil Barnes as guest, Dickon Love as
            past master (featuring limericks) and Joe Wakeling as current master
            (featuring even more limericks). The handbell band brought round a
            touch of quarks and, as two of them learnt to ring last year, should
            be congratulated for their performance.
          </NewsItem>
          <NewsItem title="Joint Outing - 17th February 2018" image={joint18}>
            Our annual joint outing with the OUS this year was organised by Joe
            and took place in Northampton. We had a good turnout , although the
            OUS had, perhaps over-ambitiously, booked a minibus for five of
            them... A good selection of towers, ranging from 6 to 10 bells, were
            grabbed - most in the city centre and then heading out to Abington
            for the final ring of the day. A note for the future: pubs in
            Northampton are very busy at 12pm on a Saturday, recommend booking a
            table to avoid a chilly lunch eaten outside!
          </NewsItem>
          <NewsItem title="Guild New Year 2018" image={ny18}>
            Our New Year's resolutions: do more ringing. Play more Bananagrams.
            Spend more time shooting each other with lasers. The Guild got a
            considerable head-start on all of these activities and more at our
            traditional new year celebrations. Attendance was at a record high,
            with fifteen hungry ringers descending on Rachel's poor unsuspecting
            parents in Swansea - but the quality of hosting was second to none.
            Two expertly-organised ringing outings were laid on, along with
            spectacular walks, overly-energetic evening games, ringing in the
            new year, and the (now-traditional) opportunity to shoot each other.
            A thoroughly enjoyable event, as always!
          </NewsItem>
          <NewsItem title="Christmas Newsletter 2017">
            <a href={letter17} download="Newsletter 2017">
              Please click here to read the 2017 newsletter from Joe Wakeling.
            </a>
          </NewsItem>
          <NewsItem
            title="Holiday to the Isle of Wight - 18th-25th August 2017"
            image={hols17}
          >
            The inaugural CUGCR summer holiday was thoroughly enjoyed by all
            involved. Our chosen destination was the Isle of Wight, with
            lodgings at Northcourt House, an amply appointed Jacobean Manor
            house with all the modern conveniences – including formal
            dining/table tennis room, barbecue terrace and grandiose gardens. We
            kept ourselves amused with trips to the beach, walks through the
            beautiful countryside, rides on steam trains, and just a tiny spot
            of ringing (including the characterful steel three at Swanmore).
            Plans are already well progressed for a follow-up event during the
            August bank holiday week next year, so watch this space!
          </NewsItem>
          <NewsItem title="Guild Week - 4th-9th August 2017">
            <p>
              In an unusual twist on the format, Guild Week 2017 was split
              between London for the weekend and St Albans for the rest, so the
              pubs and belltowers of two cities had to prepare for an upturn in
              influx. The time spent in London was a 'Who's Who' of the City's
              famous rings, with trips to the Bow bells, the Jubilee bells at
              Garlickhythe, St Magnus and the infamous new ring at Southwark,
              which we confirmed in their 'challenging' reputation. After
              rounding off the weekend with a Brick Lane curry, the next day
              brought some healthy exercise to the proceedings, all the towers
              being within walking distance of each other, and St Albans' huge
              expanse of parkland offered us plenty of chances to get some fresh
              air and sore legs. Ascending to the ringing chamber at the Abbey
              offered little respite, but the weary traveller was rewarded with
              the novelty of oak beams obscuring some other ringers from
              view.Other highlights of the week were the hospitality of the
              Blacksmith's Arms in laying on a buffet for the guild week
              meeting, and the challenge of Weathampstead's long draft on the
              last day.
            </p>
            <p>
              Despite the excess of cities and well-known towers on the trip,
              two elements of Guild Week were in short supply. Fewer than usual
              peals or quarters were scored, and due to a dearth of student
              members, post-ringing exuberance at the cheaper accommodation was
              sadly reduced. However, one of these omissions was to be put right
              a couple of weeks later when Guild members decamped to the Isle of
              Wight(and it was not the former).
            </p>
            <p>
              Thanks go to Brian Meads and Dickon Love for organising a week of
              excellent and challenging rings.
            </p>
            <p>Joe Wakeling - Master, CUGCR</p>
          </NewsItem>
          <NewsItem title="Alternative Dinner - 20th June 2017" image={alt17}>
            <p>
              Hosted this year at Hughes Hall, a debut appearance for many, the
              Alternative Dinner was as popular as ever. We turned out in our
              finery for drinks and a splendid dinner overlooking the college
              grounds. The Alternative Committee were elected afterwards -
              including the Curry Officer, Anti-Curry Officer, Quote Book
              Keeper, and so on and so forth. All that remains now is to
              remember who's doing what when the students return to Cambridge in
              October!
            </p>
            <p>
              Thanks must go to Courtney and Hannah for their organisation and
              for hosting pre- and post-dinner drinks.
            </p>
          </NewsItem>

          <NewsItem
            title="Association of Ringing Teachers: Module 1 - 29th April 2017"
            image={art}
          >
            <p>
              The Cambridge University Guild (CUGCR) hosted a Module 1 course at
              Great St Mary’s, Cambridge, at the start of our third term of the
              year. Having had a year of unprecedented enthusiasm for teaching
              and learning bellringing, we decided an ART course would be just
              the ticket to maintain this momentum going forward, and to ensure
              we were operating as effectively as possible; with short 8-week
              terms it’s important to train intensively!
            </p>
            <p>
              A group of 12 teachers – mostly CUGCR members, but with a few
              local friends – took part in the course under Graham’s able
              instruction. The day consisted of alternating theory and practical
              sessions, giving everyone a chance to try out the various
              exercises introduced on tied bells. The day was packed full of
              useful information, particularly regarding our interactions with
              the learner – making sure they feel confident, that they are
              achieving something, and that the teaching is tailored to their
              needs.
            </p>
            <p>
              The plan looking forward is to establish the CUGCR as a centre of
              teaching – with a constantly shifting undergraduate population it
              will be important that skills are passed down in group teaching
              sessions, rather than having any one particular person in charge
              for years on end. This challenge is inherent to university ringing
              in general, so I’m sure it’ll be one we can overcome.
            </p>
            <p>
              Our thanks go to Graham and the whole of the ART administration
              for putting on such an excellent day for us, and kicking off what
              I hope will be a long and prosperous campaign of teaching in
              Cambridge.
            </p>
            <p>Oliver Bardsley – Master, CUGCR</p>
          </NewsItem>
          <NewsItem title="The Boat Races - 2nd April 2017" image={boat17}>
            Once again, in collaboration with the OUS, we rang the bells on
            either side of Putney Bridge for the Cambridge vs. Oxford Boat
            Races. A quarter peal of Cambridge Major was scored at All Saints,
            Fulham while the women's race was taking place before we quickly
            rang down and ran up to the roof to watch the start of the men's
            race. It wasn't all ringing, though, we also went out for lunch and
            took a trip to the Science Museum.
          </NewsItem>

          <NewsItem
            title="Annual Guild Dinner - 18th March 2017"
            image={dinner17}
          >
            As is tradition, members of the Guild gathered from far and wide for
            the annual dinner, held this year in Peterhouse college. The day
            started well with 10 out of 10 successful quarter peals, including
            four 'first quarters' for some of our learners who started ringing
            in October 2016. Speeches from Jennie Earis as past master, Roger
            Booth as the guest speaker and Oli Bardsley as current master, tasty
            yet controversial food choices and a handbell touch (see it here on
            Bellboard) all made for a very enjoyable evening.
          </NewsItem>

          <NewsItem title="Guild New Year 2017" image={ny17}>
            This year James (Junior) took on the task of hosting 12 ringers at
            his Northamptonshire abode. The trip kicked off with a quarter peal
            and a walk for the early birds. On New Year's Eve we visited 5
            different towers, all exciting in their own special way and one of
            which required ear defenders, before ringing in the New Year at
            Brigstock. Another quarter peal followed on New Year's Day and then
            10 intrepid members of the party played some rather soggy paintball.
            Thanks must go to James and his family for cooking lots of delicious
            food and for putting up with us!
          </NewsItem>
          <NewsItem title="Christmas Newsletter 2016">
            <a href={letter16} download="Newsletter 2016">
              Please click here to read the 2016 newsletter from Oliver
              Bardsley.
            </a>
          </NewsItem>

          <NewsItem title="Christmas Dinner - 4th December 2016" image={xmas16}>
            Dinner for 18? No problem! As long as everyone brings their own
            plate, cutlery, glass and chair! Plenty of food was had by all,
            secret santa presents were swapped, and everyone took part in a
            (slightly aggressive) game of pictionary. Merry Christmas!
          </NewsItem>

          <NewsItem
            title="Southern Universities Association Weekend - 11th-13th November 2016"
            image={sua16}
          >
            Ringers from Cambridge, Southampton, Bristol, Oxford, London and
            Leicester congregated in Cambridge for a weekend of striking
            competitions, open towers, beer and dancing. Congratulations go to
            Southampton who came first in the 8-bell competition and Cambridge
            who came first in the 6-bell. See you all next year!
          </NewsItem>

          <NewsItem
            title="Freshers' Fair - 4th-5th October 2016"
            image={freshers16}
          >
            We had a successful freshers' fair hosting The Charmborough Ring on
            Parker's Piece. A pretty central location and the sound of bells
            ringing all day meant that we weren't hard to miss! Hundreds of
            people had a go and we got lots of new sign-ups. Thank you to
            everyone who helped out!
          </NewsItem>

          <NewsItem title="Guild Week - 20th-24th August 2016" image={week16}>
            Members of the Guild from far and wide descended on Bristol for five
            days of ringing and socialising. This encompassed some rather
            challenging bells within the city itself, plus day trips to Bath and
            the nearby countryside. With an average tenor weight of 24.4cwt, we
            certainly weren't taking it easy!
          </NewsItem>

          <NewsItem
            title="6-Bell Striking Competition - 9th July 2016"
            image={six16}
          >
            Six of the Guild's best took on the Cambridge branch of the Ely DA
            in a striking competition at Brinkley, we rang Cambridge Surprise
            Minor and came away with a very creditable 2nd place. We had dinner
            together, followed by a somewhat unplanned pub crawl...
          </NewsItem>
        </div>
      </div>
    </WhiteDiv>
  </Layout>
)

export default OldNews
